<template>
    <app-layout title="Aanvragen">
        <template #header>
            <page-title :title="request.reference" />
        </template>

        <template #pageContent>
            <div class="mb-4" v-if="request.status !== 'cancelled'">
                <Button
                    htmlType="a"
                    buttonClass="edit"
                    text="Bewerken"
                    :href="route('requests.edit', { 'request': request.id })"
                    v-if="this.$page.props.user.permissions.includes('requests.edit') && (request.partner === null || (request.partner.code !== 'whise' && request.partner.code !== 'cib'))"
                />
                <ModalAttachments
                    :request="request"
                    :attachments="attachments"
                    :attachmentTypes="attachmentTypes"
                    :attachmentsPath="attachmentsPath"
                />
                <Button
                    buttonClass="send"
                    :disabled="!hasOffer || request.approved == 1"
                    text="Offerte versturen"
                    @click="SendOffer"
                    :loading="sendingOffer"
                    v-if="requestTypeOptions[request.request_type_id].includes('Offerte')"
                />
                <Button
                    buttonClass="success"
                    :disabled="request.approved == 1"
                    text="Goedkeuren"
                    @click="approveRequest"
                    :loading="approving"
                    v-if="requestTypeOptions[request.request_type_id].includes('Offerte')"
                />
                <ModalPlanVisit
                    :request="request"
                    :requestTypeOptions="requestTypeOptions"
                    :executorOptions="executorOptions"
                    :replanVisit="replanVisit"
                    @visitReplanned="visitReplanned"
                    v-model:visitToReplan="visitToReplan"
                    :extraVisit="extraVisit"
                />
                <Modal
                    buttonText="Bezoek registreren"
                    :buttonDisabled="Object.keys(visitOptions).length < 1 || request.status !== 'planned'"
                    ref="modalRegisterVisit"
                    v-if="this.$page.props.user.permissions.includes('requests.registervisit')"
                >
                    <div>
                        <Form @submitted="postRegisterVisit">
                            <h3>Bezoek registeren</h3>
                            <Select
                                label="Bezoek"
                                name="visit_id"
                                :options="visitOptions"
                                v-model="formRegisterVisit.visit_id"
                                :error="formRegisterVisit.errors.visit_id"
                                layout="vertical"
                                v-if="Object.keys(visitOptions).length > 1"
                            />
                            <div class="flex flex-row">
                                <div class="pr-2 w-1/2">
                                    <Input
                                        type="number"
                                        label="Tijd transport (u:m) *"
                                        name="transport_time_hours"
                                        min="0"
                                        placeholder="uur"
                                        layout="vertical"
                                        v-model="formRegisterVisit.transport_time_hours"
                                        :error="formRegisterVisit.errors.transport_time_hours"
                                    />
                                </div>
                                <div class="pl-2 w-1/2">
                                    <Input
                                        type="number"
                                        label="&nbsp;"
                                        name="transport_time_minutes"
                                        min="0"
                                        max="59"
                                        placeholder="minuten"
                                        layout="vertical"
                                        v-model="formRegisterVisit.transport_time_minutes"
                                        :error="formRegisterVisit.errors.transport_time_minutes"
                                    />
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="pr-2 w-1/2">
                                    <Input
                                        type="number"
                                        label="Tijd bezoek (u:m) *"
                                        name="visit_time_hours"
                                        min="0"
                                        placeholder="uur"
                                        layout="vertical"
                                        v-model="formRegisterVisit.visit_time_hours"
                                        :error="formRegisterVisit.errors.visit_time_hours"
                                    />
                                </div>
                                <div class="pl-2 w-1/2">
                                    <Input
                                        type="number"
                                        label="&nbsp;"
                                        name="visit_time_minutes"
                                        min="0"
                                        max="59"
                                        placeholder="minuten"
                                        layout="vertical"
                                        v-model="formRegisterVisit.visit_time_minutes"
                                        :error="formRegisterVisit.errors.visit_time_minutes"
                                    />
                                </div>
                            </div>
                            <Input
                                type="text"
                                label="Qlab order"
                                name="qlab"
                                v-model="formRegisterVisit.qlab"
                                :error="formRegisterVisit.errors.qlab"
                                layout="vertical"
                            />
                            <Input
                                type="text"
                                label="LIMS nummer"
                                name="lims"
                                v-model="formRegisterVisit.lims"
                                :error="formRegisterVisit.errors.lims"
                                layout="vertical"
                            />
                            <Input
                                type="number"
                                label="Aantal stalen"
                                name="samples"
                                :required="true"
                                v-model="formRegisterVisit.samples"
                                :error="formRegisterVisit.errors.samples"
                                layout="vertical"
                            />
                            <Input
                                label="Extra bezoek inplannen"
                                name="extra_visit"
                                id="extra_visit"
                                type="checkbox"
                                :checked="formRegisterVisit.extra_visit"
                                value="1"
                                v-model="formRegisterVisit.extra_visit"
                            />

                            <Button
                                text="Opslaan"
                                buttonClass="save"
                                type="submit"
                                :loading="formRegisterVisit.processing"
                                class="self-end"
                            />
                        </Form>
                    </div>
                </Modal>
                <Modal
                    buttonText="Rapporteren"
                    :buttonDisabled="request.status === 'reported'
                        || request.status !== 'in_progress'"
                    ref="modalReport"
                    v-if="this.$page.props.user.permissions.includes('requests.report')"
                >
                    <div>
                        <Form @submitted="postFormReport">
                            <h3>Rapporteren</h3>
                            <Input
                                type="date"
                                label="Datum rapportage"
                                name="reported_at"
                                :required="true"
                                v-model="formReport.reported_at"
                                :error="formReport.errors.reported_at"
                                layout="vertical"
                            />
                            <div class="flex flex-row items-end mb-2">
                                <div class="pr-2 w-1/2">
                                    <Input
                                        type="number"
                                        label="Tijd rapportage (u:m)&nbsp;*"
                                        name="spent_time_hours"
                                        placeholder="uur"
                                        min="0"
                                        layout="vertical"
                                        v-model="formReport.spent_time_hours"
                                        :error="formReport.errors.spent_time_hours"
                                    />
                                </div>
                                <div class="pl-2 w-1/2">
                                    <Input
                                        type="number"
                                        label="&nbsp;"
                                        name="spent_time_minutes"
                                        placeholder="minuten"
                                        min="0"
                                        max="59"
                                        layout="vertical"
                                        v-model="formReport.spent_time_minutes"
                                        :error="formReport.errors.spent_time_minutes"
                                    />
                                </div>
                            </div>
                            <Input
                                label="OVAM rapport niet van toepassing"
                                name="no_ovam_report"
                                id="no_ovam_report"
                                type="checkbox"
                                :checked="Boolean(formReport.no_ovam_report)"
                                value="1"
                                v-model="formReport.no_ovam_report"
                            />
                            <Input
                                type="date"
                                label="OVAM rapportdatum"
                                name="certificate_date"
                                :required="!formReport.no_ovam_report"
                                v-model="formReport.certificate_date"
                                :error="formReport.errors.certificate_date"
                                layout="vertical"
                                v-if="!formReport.no_ovam_report"
                            />
                            <Select
                                label="Conclusie"
                                name="ovam_conclusion_id"
                                :required="!formReport.no_ovam_report"
                                :options="ovamConclusions"
                                v-model="formReport.ovam_conclusion_id"
                                :error="formReport.errors.ovam_conclusion_id"
                                layout="vertical"
                                v-if="!formReport.no_ovam_report"
                            />
                            <InputGroup label="Plannen aanwezig?" :error="formReport.errors.plans_available" layout="vertical">
                                <Input
                                    label="Ja"
                                    name="plans_available"
                                    id="plans_available_1"
                                    type="radio"
                                    value="1"
                                    :checked="formReport.plans_available == 1"
                                    v-model="formReport.plans_available"
                                />
                                <Input
                                    label="Deels"
                                    name="plans_available"
                                    id="plans_available_2"
                                    type="radio"
                                    value="2"
                                    :checked="formReport.plans_available == 2"
                                    v-model="formReport.plans_available"
                                />
                                <Input
                                    label="Nee"
                                    name="plans_available"
                                    id="plans_available_0"
                                    type="radio"
                                    value="0"
                                    :checked="formReport.plans_available == 0"
                                    v-model="formReport.plans_available"
                                />
                            </InputGroup>
                            <Input
                                :label="'Sleep OVAM rapport(en) hierin of klik hier'"
                                name="report_attachments"
                                type="file"
                                :required="request.report === null || request.report.reported_at === null"
                                accept=".pdf"
                                :multiple="true"
                                :fileDragDrop="true"
                                heightDragDrop="130"
                                v-model="formReport.report_attachments"
                                :error="formReport.errors.report_attachments"
                            />
                            <Button
                                text="Opslaan"
                                buttonClass="save"
                                type="submit"
                                :loading="formReport.processing"
                                class="self-end mt-2"
                            />
                        </Form>
                    </div>
                </Modal>
                <Modal
                    buttonText="Rapport(en) verzenden"
                    :buttonDisabled="request.status !== 'reported' && request.status !== 'invoiced' && request.status !== 'pro-forma'"
                    ref="modalSendReport"
                    v-if="this.$page.props.user.permissions.includes('requests.report')"
                >
                    <Form @submitted="postFormSendReport">
                        <h3>Rapport(en) verzenden</h3>
                        <strong>Het OVAM rapport zal automatisch worden bezorgd aan de geselecteerde personen:</strong>
                        <InputGroup :error="formSendReport.errors.to" layout="vertical">
                            <template v-for="(receiver, key) in sendOVAMReportTo">
                                <Input
                                    :label="receiver"
                                    name="to"
                                    :id="receiver + '_' + key"
                                    type="checkbox"
                                    :value="receiver"
                                    :checked="true"
                                    v-model="formSendReport.to"
                                />
                            </template>
                        </InputGroup>
                        <strong>Extra ontvangers (e-mailadres)</strong>
                        <span class="text-xs">Meerdere ontvangers kan je scheiden met een ; (bv. email1@eccaplus.be; email2@eccaplus.be)</span>
                        <Textarea
                            name="extra_emails"
                            v-model="formSendReport.extra_emails"
                            :error="formSendReport.errors.extra_emails"
                            layout="vertical"
                        />
                        <h4 class="mt-4">Rapport(en)</h4>
                        <p class="text-sm" v-if="Object.keys(externalRequestForms).length > 1 && formSendReport.to.includes('Dewaele IAM')">Indien de OVAM rapporten automatisch naar Dewaele (IAM) moeten worden verzonden, selecteer dan het bijhorende opdrachtformulier.</p>
                        <InputGroup :error="formSendReport.errors.attachment_ids" layout="vertical">
                            <template v-for="(attachment, key) in request.attachments">
                                <template v-if="attachment.type === 'OVAM rapport'">
                                    <Input
                                        :label="attachment.file"
                                        name="to"
                                        :id="attachment.id.toString()"
                                        type="checkbox"
                                        :value="attachment.id"
                                        :checked="true"
                                        v-model="formSendReport.attachment_ids"
                                    />
                                    <Select
                                        label="Opdrachtformulier Dewaele"
                                        name="request_form_external_id"
                                        :options="externalRequestForms"
                                        layout="vertical"
                                        v-model="formSendReport.attachment_external_ids[attachment.id]"
                                        v-if="Object.keys(externalRequestForms).length > 1 && formSendReport.to.includes('Dewaele IAM') && formSendReport.attachment_ids.includes(attachment.id)"
                                    />
                                </template>
                            </template>
                        </InputGroup>
                        <Button
                            text="Verzenden"
                            buttonClass="send"
                            type="submit"
                            :loading="formSendReport.processing"
                            class="self-end mt-2"
                        />
                    </Form>
                </Modal>
                <Modal
                    buttonText="Pro-forma"
                    :buttonDisabled="request.status !== 'reported'"
                    ref="modalProForma"
                    v-if="requestTypeOptions[request.request_type_id].includes('Bestek') && this.$page.props.user.permissions.includes('accountancy')"
                >
                    <div>
                        <Form @submitted="postFormProForma">
                            <h3>Pro-forma</h3>
                            <Textarea
                                label="Opmerking"
                                name="remark"
                                v-model="formProForma.remark"
                                :error="formProForma.errors.remark"
                                layout="vertical"
                            />
                            <div class="flex">
                                <Button
                                    text="Opslaan"
                                    buttonClass="save"
                                    type="submit"
                                    :loading="formProForma.processing"
                                    class="self-end"
                                />
                            </div>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    buttonText="Nafacturatie"
                    :buttonDisabled="request.post_invoice !== null"
                    ref="modalPostInvoice"
                    v-if="this.$page.props.user.permissions.includes('requests.postinvoicing')"
                >
                    <div>
                        <Form @submitted="postFormPostInvoice">
                            <h3>Nafacturatie</h3>
                            <Select
                                label="Reden"
                                name="post_invoice_reason_id"
                                :required="true"
                                :options="postInvoiceReasonOptions"
                                v-model="formPostInvoice.post_invoice_reason_id"
                                :error="formPostInvoice.errors.post_invoice_reason_id"
                                layout="vertical"
                            />
                            <Textarea
                                name="info_asbestos"
                                v-model="formPostInvoice.info_asbestos"
                                :error="formPostInvoice.errors.info_asbestos"
                                layout="vertical"
                                v-if="postInvoiceReasonOptions[formPostInvoice.post_invoice_reason_id] === 'Andere'"
                            />
                            <Input
                                label="Excel nafacturatie"
                                name="post_invoice_attachment"
                                type="file"
                                accept=".xls,.xlsx"
                                :multiple="false"
                                :fileDragDrop="true"
                                heightDragDrop="130"
                                v-model="formPostInvoice.post_invoice_attachment"
                                :error="formPostInvoice.errors.post_invoice_attachment"
                            />
                            <div class="flex justify-between items-center">
                                <a
                                    href="/various/download-template-post-invoice"
                                    class="mr-4"
                                    v-if="this.$page.props.user.permissions.includes('templates.postinvoice')"
                                >
                                    Sjabloon nafacturatie downloaden
                                </a>

                                <Button
                                    text="Opslaan"
                                    buttonClass="save"
                                    type="submit"
                                    :loading="formPostInvoice.processing"
                                    class="self-end"
                                />
                            </div>
                        </Form>
                    </div>
                </Modal>
                <ModalCreditNote
                    :request="request"
                    :createCreditNote="createCreditNote"
                    :cancelRequest="cancelRequest"
                    :buttonDisabled="request.credit_note !== null"
                    v-if="this.$page.props.user.permissions.includes('requests.creditnote')"
                />
                <Modal
                    buttonText="Facturatie info"
                    ref="modalInvoiceInfo"
                    v-if="this.$page.props.user.permissions.includes('accountancy')"
                >
                    <div>
                        <Form @submitted="postFormInvoiceInfo">
                            <h3>Facturatie info</h3>
                            <Input
                                label="Zelfde adres als inspectieadres"
                                name="same_address"
                                id="same_address"
                                type="checkbox"
                                :checked="formInvoiceInfo.same_address"
                                value="1"
                                v-model="formInvoiceInfo.same_address"
                                @change="sameAddress"
                            />
                            <div class="grid grid-cols-2 gap-6 flex">
                                <div>
                                    <Input
                                        type="text"
                                        label="Naam"
                                        name="invoice_customer_name"
                                        :required="(requestTypeOptions[request.request_type_id] && requestTypeOptions[request.request_type_id].includes('Webshop')) || request.invoice_customer_id !== null"
                                        v-model="formInvoiceInfo.invoice_customer_name"
                                        :error="formInvoiceInfo.errors.invoice_customer_name"
                                        layout="vertical"
                                        :disabled="Boolean(formInvoiceInfo.same_address)"
                                    />
                                    <Input
                                        type="text"
                                        label="Bedrijf"
                                        name="invoice_customer_company"
                                        v-model="formInvoiceInfo.invoice_customer_company"
                                        :error="formInvoiceInfo.errors.invoice_customer_company"
                                        layout="vertical"
                                    />
                                    <Input
                                        type="text"
                                        label="BTW nummer"
                                        name="invoice_customer_vat_number"
                                        v-model="formInvoiceInfo.invoice_customer_vat_number"
                                        :error="formInvoiceInfo.errors.invoice_customer_vat_number"
                                        layout="vertical"
                                    />
                                    <Input
                                        type="text"
                                        label="Straat + nr"
                                        name="invoice_customer_address"
                                        :required="(requestTypeOptions[request.request_type_id] && requestTypeOptions[request.request_type_id].includes('Webshop')) || request.invoice_customer_id !== null"
                                        v-model="formInvoiceInfo.invoice_customer_address"
                                        :error="formInvoiceInfo.errors.invoice_customer_address"
                                        layout="vertical"
                                        :disabled="Boolean(formInvoiceInfo.same_address)"
                                    />
                                    <Input
                                        type="number"
                                        label="Postcode"
                                        name="invoice_customer_postal_code"
                                        max="9999"
                                        v-model="formInvoiceInfo.invoice_customer_postal_code"
                                        :error="formInvoiceInfo.errors.invoice_customer_postal_code"
                                        layout="vertical"
                                        :disabled="Boolean(formInvoiceInfo.same_address)"
                                    />
                                    <Input
                                        type="text"
                                        label="Plaats"
                                        name="invoice_customer_place"
                                        :required="(requestTypeOptions[request.request_type_id] && requestTypeOptions[request.request_type_id].includes('Webshop')) || request.invoice_customer_id !== null"
                                        v-model="formInvoiceInfo.invoice_customer_place"
                                        :error="formInvoiceInfo.errors.invoice_customer_place"
                                        layout="vertical"
                                        :disabled="Boolean(formInvoiceInfo.same_address)"
                                    />
                                    <Input
                                        type="text"
                                        label="Landcode"
                                        name="invoice_customer_country_code"
                                        :required="(requestTypeOptions[request.request_type_id] && requestTypeOptions[request.request_type_id].includes('Webshop')) || request.invoice_customer_id !== null"
                                        v-model="formInvoiceInfo.invoice_customer_country_code"
                                        :error="formInvoiceInfo.errors.invoice_customer_country_code"
                                        layout="vertical"
                                    />
                                </div>
                                <div>
                                    <Input
                                        type="text"
                                        label="Email"
                                        name="invoice_customer_email"
                                        v-model="formInvoiceInfo.invoice_customer_email"
                                        :error="formInvoiceInfo.errors.invoice_customer_email"
                                        layout="vertical"
                                    />
                                    <Input
                                        type="text"
                                        label="Telefoon"
                                        name="invoice_customer_phone"
                                        v-model="formInvoiceInfo.invoice_customer_phone"
                                        :error="formInvoiceInfo.errors.invoice_customer_phone"
                                        layout="vertical"
                                    />
                                    <Input
                                        type="text"
                                        label="Factuurnummer"
                                        name="invoice_number"
                                        :required="(requestTypeOptions[request.request_type_id] && requestTypeOptions[request.request_type_id].includes('Webshop')) || request.invoice_customer_id !== null"
                                        v-model="formInvoiceInfo.invoice_number"
                                        :error="formInvoiceInfo.errors.invoice_number"
                                        layout="vertical"
                                    />
                                    <Input
                                        type="double"
                                        label="Facturatiebedrag"
                                        name="invoice_amount"
                                        :required="(requestTypeOptions[request.request_type_id] && requestTypeOptions[request.request_type_id].includes('Webshop'))"
                                        v-model="formInvoiceInfo.invoice_amount"
                                        :error="formInvoiceInfo.errors.invoice_amount"
                                        layout="vertical"
                                    />
                                    <Input
                                        type="date"
                                        label="Datum betaling"
                                        name="invoice_paid_at"
                                        v-model="formInvoiceInfo.invoice_paid_at"
                                        :error="formInvoiceInfo.errors.invoice_paid_at"
                                        layout="vertical"
                                    />
                                    <Textarea
                                        label="Info"
                                        name="invoice_info"
                                        v-model="formInvoiceInfo.invoice_info"
                                        :error="formInvoiceInfo.errors.invoice_info"
                                        layout="vertical"
                                    />
                                </div>
                            </div>
                            <Button
                                text="Opslaan"
                                buttonClass="save"
                                type="submit"
                                :loading="formInvoiceInfo.processing"
                                class="self-end"
                            />
                        </Form>
                    </div>
                </Modal>
                <Modal
                    buttonText="Gefactureerd"
                    ref="modalInvoiced"
                    v-if="(request.status === 'reported' || request.status === 'pro-forma') && this.$page.props.user.permissions.includes('accountancy') && (requestTypeOptions[request.request_type_id]
                        && (requestTypeOptions[request.request_type_id].includes('Offerte') || requestTypeOptions[request.request_type_id].includes('Bestek')))"
                >
                    <Form @submitted="postFormInvoiced">
                        <h3>Gefactureerd</h3>
                        <p>Wijzigt de status voor deze aanvraag naar gefactureerd.</p>
                        <Input
                            type="text"
                            label="Factuurnummer"
                            name="invoice_number"
                            :required="true"
                            v-model="formInvoiced.invoice_number"
                            :error="formInvoiced.errors.invoice_number"
                            layout="vertical"
                        />
                        <Input
                            type="double"
                            label="Facturatiebedrag"
                            name="invoice_amount"
                            :required="!formInvoiced.no_invoice"
                            v-model="formInvoiced.invoice_amount"
                            :error="formInvoiced.errors.invoice_amount"
                            layout="vertical"
                            v-if="(request.request_type.type === 'Offerte' || request.request_type.type === 'Bestek') &&
                                !formInvoiced.no_invoice"
                        />
                        <Input
                            label="Geen facturatie"
                            name="no_invoice"
                            id="no_invoice"
                            type="checkbox"
                            :checked="Boolean(formInvoiced.no_invoice)"
                            value="1"
                            v-model="formInvoiced.no_invoice"
                        />
                        <Button
                            text="Opslaan"
                            buttonClass="save"
                            type="submit"
                            :loading="formInvoiced.processing"
                            class="self-end"
                        />
                    </Form>
                </Modal>
                <Cancel :request="request" @createRequestCreditNote="createRequestCreditNote" />

<!--                Failed emails notification-->
                <div
                    class="bg-red-300 text-red-800 flex w-full p-3 mt-2 mb-4 rounded-md font-semibold"
                    v-if="Object.keys(failedEmails).length > 0"
                >
                    <div class="text-2xl pr-2">
                        <i class="fas fa-exclamation-circle mt-2"></i>
                    </div>
                    <div class="pt-1 pr-2 flex-auto">
                        E-mail(s) die niet konden worden verzonden:
                        <Table class="border-0 w-2/3">
                            <tr v-for="failedEmail in failedEmails" class="nohover">
                                <Td class="border-0"><strong>E-mail: </strong>{{ failedEmail.mail_to }}</Td>
                                <Td class="border-0"><strong>Onderwerp: </strong>{{ failedEmail.subject }}</Td>
                                <Td class="border-0">
                                    <Button
                                        text="Opnieuw verzenden"
                                        size="small"
                                        buttonClass="redo"
                                        @click="resendEmail(failedEmail)"
                                        :loading="resendingEmail[failedEmail.id]"
                                    />
                                    <Button
                                        size="small"
                                        title="Bewerken"
                                        buttonClass="edit"
                                        @click="editResendEmail(failedEmail)"
                                    />
                                    <Button
                                        size="small"
                                        title="Verwijderen"
                                        buttonClass="delete"
                                        @click="deleteResendEmail(failedEmail)"
                                    />
                                </Td>
                            </tr>
                        </Table>
                    </div>
                </div>
                <Modal
                    visible="hidden"
                    ref="modalEditResendEmail"
                >
                    <Form @submitted="postEditResendEmail">
                        <Input
                            type="email"
                            label="E-mail"
                            name="mail_to"
                            :required="true"
                            v-model="formEditResendEmail.mail_to"
                            :error="formEditResendEmail.errors.mail_to"
                            layout="vertical"
                        />
                        <Input
                            type="text"
                            label="Onderwerp"
                            name="subject"
                            :required="true"
                            v-model="formEditResendEmail.subject"
                            :error="formEditResendEmail.errors.subject"
                            layout="vertical"
                        />
                        <Button
                            text="Opslaan"
                            buttonClass="save"
                            type="submit"
                            :loading="formEditResendEmail.processing"
                            class="self-end"
                        />
                    </Form>
                </Modal>

                <div
                    class="bg-blue-light-300 text-blue-dark-500 flex w-full p-3 mt-2 mb-4 rounded-md font-semibold"
                    v-if="request.status === 'planned' && request.visits"
                >
                    <div class="text-2xl pr-2">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="pt-1 pr-2 flex-auto">
                        Geplande datum bezoek:
                        <template v-if="request.visits && request.visits.hasOwnProperty(request.visits.length - 1)">
                            {{ moment(request.visits[request.visits.length - 1].planned_at).format('DD-MM-YYYY') }}<br>
                            <template v-if="request.visits[request.visits.length - 1].start_time">
                                Starttijd: {{ moment(request.visits[request.visits.length - 1].start_time, 'HH:mm:ss').format('HH:mm') }}<br>
                            </template>
                            <template v-if="request.visits[request.visits.length - 1].end_time">
                                Eindtijd: {{ moment(request.visits[request.visits.length - 1].end_time, 'HH:mm:ss').format('HH:mm') }}<br>
                            </template>
                            ADI: {{ allExecutors[request.visits[request.visits.length - 1].executor] }}
                        </template>
                    </div>
                </div>
            </div>
            <div>
                <div class="border-b-[1px] border-blue-dark-500 pb-4 mb-4">
                    <h2>Algemene informatie</h2>
                    <div class="w-4/6 grid grid-cols-2 gap-6">
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Referentie:</Td>
                                    <Td class="border-0 w-1/2">{{ request.reference }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Status:</Td>
                                    <Td class="border-0">{{ statusses[request.status] }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Type:</Td>
                                    <Td class="border-0">{{ request.request_type.type }}</Td>
                                </tr>
                                <tr v-if="request.request_type.type === 'Bestek'">
                                    <Td class="border-0 pl-0">Bestek:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.estimate">
                                            {{ request.estimate.name }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Opdracht:</Td>
                                    <Td class="border-0">{{ request.assignment_type.name }}</Td>
                                </tr>
                                <tr v-if="request.assignment_type.product_attributes.some(attr => attr.type === 'surface')">
                                    <Td class="border-0 pl-0">Oppervlakte categorie:</Td>
                                    <Td class="border-0">
                                        <span v-html="request.surface.size" v-if="request.surface"></span>
                                    </Td>
                                </tr>
                                <tr v-if="request.assignment_type.product_attributes.some(attr => attr.type === 'surface')">
                                    <Td class="border-0 pl-0">Oppervlakte:</Td>
                                    <Td class="border-0">
                                        {{ request.surface_area }}<template v-if="request.surface_area">m²</template>
                                    </Td>
                                </tr>
                                <tr v-if="request.assignment_type.product_attributes.some(attr => attr.type === 'residences')">
                                    <Td class="border-0 pl-0">Aantal wooneenheden:</Td>
                                    <Td class="border-0">
                                        {{ request.residences }}
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Klant:</Td>
                                    <Td class="border-0">{{ request.customer }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Email:</Td>
                                    <Td class="border-0">{{ request.mail_contact }}</Td>
                                </tr>
                                <tr
                                    v-if="request.request_type.type.includes('Dewaele') || request.request_type.type.includes('Offerte')
                                    || request.request_type.type.includes('Bestek') || request.partner_id != null"
                                >
                                    <Td class="border-0 pl-0">Dossiernummer:</Td>
                                    <Td class="border-0">{{ request.external_reference }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Extra info:</Td>
                                    <Td class="border-0">{{ request.info }}</Td>
                                </tr>
                            </Table>
                        </div>
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Inspectie adres:</Td>
                                    <Td class="border-0 w-1/2">
                                        {{ request.inspection_address.name }}<br>
                                        {{ request.inspection_address.address }}<br>
                                        {{ request.inspection_address.postal_code }} {{ request.inspection_address.place }}
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Voorkeursdatum en -tijd:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.preference_date">
                                            {{ moment(request.preference_date).format('DD-MM-YYYY') }}
                                            <span v-if="request.preference_time"> {{ moment(request.preference_time, 'HH:mm:ss').format('HH:mm') }}</span>
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Aangevraagd op:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.requested_at">
                                            {{ moment(request.requested_at).format('DD-MM-YYYY') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr v-if="request.partner">
                                    <Td class="border-0 pl-0 w-1/2">Partner:</Td>
                                    <Td class="border-0 w-1/2">
                                        {{ request.partner.name }}
                                    </Td>
                                </tr>
                                <tr v-if="request.broker">
                                    <Td class="border-0 pl-0 w-1/2">Makelaar:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.broker.company">
                                            {{ request.broker.company }}<br>
                                        </template>
                                        <template v-if="request.broker.person">
                                            {{ request.broker.person }}<br>
                                        </template>
                                        <template v-if="request.broker.phone">
                                            {{ request.broker.phone }}<br>
                                        </template>
                                        {{ request.broker.mail }}
                                    </Td>
                                </tr>
                                <tr v-if="requestTypeOptions[request.request_type_id].includes('Offerte')">
                                    <Td class="border-0 pl-0 w-1/2">Goedkeuring offerte:</Td>
                                    <Td class="border-0 w-1/2">
                                        {{ (request.approved) ? 'Goedgekeurd' : 'Niet goedgekeurd' }}
                                    </Td>
                                </tr>
                            </Table>
                        </div>
                    </div>
                </div>
                <div
                    class="border-b-[1px] border-blue-dark-500 pb-4 mb-4"
                    v-if="(request.invoice_customer || request.invoice) && this.$page.props.user.permissions.includes('invoices.info')"
                >
                    <h2>Facturatie info</h2>
                    <div class="w-4/6 grid grid-cols-2 gap-6">
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Naam:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.name }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Bedrijf:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.company }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">BTW nummer:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.vat_number }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Adres:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.address }}<br>
                                            {{ request.invoice_customer.postal_code }} {{ request.invoice_customer.place }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Landcode:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.country_code }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Email:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.email }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Telefoon:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.invoice_customer">
                                            {{ request.invoice_customer.phone }}
                                        </template>
                                    </Td>
                                </tr>
                            </Table>
                        </div>
                        <div>
                            <Table class="border-0" v-if="request.invoice">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Factuurnummer:</Td>
                                    <Td class="border-0 w-1/2">{{ request.invoice.number }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Factuurbedrag:</Td>
                                    <Td class="border-0">{{ request.invoice.amount }}<span v-if="request.invoice.amount">€</span></Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Datum betaling:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.status === 'cancelled'">
                                            Geannuleerd
                                        </template>
                                        <template v-else-if="request.invoice.paid_at === null">
                                            Niet gekend
                                        </template>
                                        <template v-else>
                                            {{ moment(request.invoice.paid_at).format('DD-MM-YYYY') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Info:</Td>
                                    <Td class="border-0 w-1/2">{{ request.invoice.info }}</Td>
                                </tr>
                            </Table>
                        </div>
                    </div>
                </div>
                <div class="border-b-[1px] border-blue-dark-500 pb-4 mb-4" v-if="request.visits.length > 0">
                    <h2>Bezoek</h2>
                    <div class="mb-2">
                        Bezoek afgerond: {{ ((request.visits.length >= 1 && Object.keys(visitOptions).length < 1) || request.status === 'reported' || request.status === 'invoiced') ? 'Ja' : 'Nee' }}
                    </div>
                    <div class="w-4/6 grid grid-cols-2 gap-6 border-t-[1px] border-gray-200 pt-4 mt-4" v-for="visit in request.visits">
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Geplande datum:</Td>
                                    <Td class="border-0 w-1/2">{{ moment(visit.planned_at).format('DD-MM-YYYY') }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Starttijd:</Td>
                                    <Td class="border-0">
                                        <template v-if="visit.start_time">
                                            {{ moment(visit.start_time, 'HH:mm:ss').format('HH:mm') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Eindtijd:</Td>
                                    <Td class="border-0">
                                        <template v-if="visit.end_time">
                                            {{ moment(visit.end_time, 'HH:mm:ss').format('HH:mm') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">ADI:</Td>
                                    <Td class="border-0">{{ allExecutors[visit.executor] }}</Td>
                                </tr>
                                <tr v-if="visit.key">
                                    <Td class="border-0 pl-0">Ophalen sleutel:</Td>
                                    <Td class="border-0">{{ visit.key_address }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Extra info:</Td>
                                    <Td class="border-0">{{ visit.info }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Contact persoon:</Td>
                                    <Td class="border-0">{{ visit.contact_person }}</Td>
                                </tr>
                            </Table>
                        </div>
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Tijd transport:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="visit.transport_time">
                                            {{ moment(visit.transport_time, 'HH:mm:ss').format('Hu.mm') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Tijd bezoek:</Td>
                                    <Td class="border-0">
                                        <template v-if="visit.visit_time">
                                            {{ parseInt(visit.visit_time.substring(0, 2)) + 'u.' + visit.visit_time.substring(3, 5) }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Qlab order:</Td>
                                    <Td class="border-0">{{ visit.qlab }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">LIMS nummer:</Td>
                                    <Td class="border-0">{{ visit.lims }}</Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Aantal stalen:</Td>
                                    <Td class="border-0">{{ visit.samples }}</Td>
                                </tr>
<!--                                If only planned, but not registered yet-->
                                <tr class="nohover"
                                    v-if="visit.transport_time === null && visit.visit_time === null && request.status === 'planned'
                                        && this.$page.props.user.permissions.includes('requests.planvisit')">
                                    <Td class="border-0 pl-0" colspan="2">
                                        <Button
                                            text="Bezoek herinplannen"
                                            buttonClass="redo"
                                            @click="replanRequestVisit(visit)"
                                        />
                                    </Td>
                                </tr>
                            </Table>
                        </div>
                    </div>

                    <div class="mt-2" v-if="request.status === 'in_progress' && this.$page.props.user.permissions.includes('requests.registervisit')">
                        <Button
                            text="Bezoek registratie info bewerken"
                            @click="editRegisterVisit"
                        />
                    </div>
                </div>
                <div class="border-b-[1px] border-blue-dark-500 pb-4 mb-4" v-if="request.report">
                    <h2>Rapportage</h2>
                    <div class="w-4/6 grid grid-cols-2 gap-6">
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Duedate:</Td>
                                    <Td class="border-0 w-1/2">
                                        {{ (request.report.duedate !== null) ? moment(request.report.duedate).format('DD-MM-YYYY') : '/' }}
                                    </Td>
                                </tr>
                                <tr v-if="request.report.duedate !== null">
                                    <Td class="border-0 pl-0">Overdue info:</Td>
                                    <Td class="border-0">
                                        {{ request.report.overdue_info }}
                                    </Td>
                                </tr>
                                <tr v-if="request.report.duedate !== null">
                                    <Td class="border-0 pl-0">Nieuwe duedate:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.report.new_duedate">
                                            {{  moment(request.report.new_duedate).format('DD-MM-YYYY') }}
                                        </template>
                                        <template v-else-if="request.report.overdue_info !== null && moment().isAfter(moment(request.report.duedate))">
                                            Datum onbekend
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Plannen aanwezig:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.report.plans_available !== null">
                                            <template v-if="request.report.plans_available == 0">
                                                Nee
                                            </template>
                                            <template v-else-if="request.report.plans_available == 1">
                                                Ja
                                            </template>
                                            <template v-else="request.report.plans_available == 2">
                                                Deels
                                            </template>
                                        </template>
                                    </Td>
                                </tr>
                                <tr class="nohover" v-if="request.report.reported_at === null &&
                                    this.$page.props.user.permissions.includes('requests.report')">
                                    <Td class="border-0 pl-0" colspan="2">
                                        <Modal
                                            buttonText="Toevoegen duedate info"
                                            ref="modalDuedateInfo"
                                        >
                                            <div>
                                                <Form @submitted="postFormDuedateInfo">
                                                    <h3>Duedate info</h3>
                                                    Due date: {{ moment(request.report.duedate).format('DD-MM-YYYY') }}

                                                    <Input
                                                        label="Datum onbekend"
                                                        name="duedate_unknown"
                                                        id="duedate_unknown"
                                                        type="checkbox"
                                                        :checked="Boolean(formDuedateInfo.duedate_unknown)"
                                                        value="1"
                                                        v-model="formDuedateInfo.duedate_unknown"
                                                        class="mt-4"
                                                    />
                                                    <Input
                                                        type="date"
                                                        label="Nieuwe duedate"
                                                        name="new_duedate"
                                                        :required="!formDuedateInfo.duedate_unknown && moment().isAfter(moment(request.report.duedate))"
                                                        :disabled="formDuedateInfo.duedate_unknown"
                                                        v-model="formDuedateInfo.new_duedate"
                                                        :error="formDuedateInfo.errors.new_duedate"
                                                        layout="vertical"
                                                    />
<!--                                                    <Select-->
<!--                                                        label="Reden overdue"-->
<!--                                                        name="overdue_reason_id"-->
<!--                                                        :required="true"-->
<!--                                                        :options="overdueReasonOptions"-->
<!--                                                        v-model="formDuedateInfo.overdue_reason_id"-->
<!--                                                        :error="formDuedateInfo.errors.overdue_reason_id"-->
<!--                                                        layout="vertical"-->
<!--                                                    />-->
                                                    <Textarea
                                                        label="Overdue info"
                                                        name="overdue_info"
                                                        :required="true"
                                                        v-model="formDuedateInfo.overdue_info"
                                                        :error="formDuedateInfo.errors.overdue_info"
                                                        layout="vertical"
                                                    />

                                                    <Button
                                                        text="Opslaan"
                                                        buttonClass="save"
                                                        type="submit"
                                                        :loading="formDuedateInfo.processing"
                                                        class="self-end"
                                                    />
                                                </Form>
                                            </div>
                                        </Modal>
                                    </Td>
                                </tr>
                            </Table>
                        </div>
                        <div>
                            <Table class="border-0">
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Datum rapportage:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.report.reported_at">
                                            {{ moment(request.report.reported_at).format('DD-MM-YYYY') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0">Tijd rapportage:</Td>
                                    <Td class="border-0">
                                        <template v-if="request.report.spent_time">
                                            {{ moment(request.report.spent_time, 'HH:mm:ss').format('Hu.mm') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">OVAM rapportdatum:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.report.certificate_date">
                                            {{ moment(request.report.certificate_date).format('DD-MM-YYYY') }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr>
                                    <Td class="border-0 pl-0 w-1/2">Conclusie:</Td>
                                    <Td class="border-0 w-1/2">
                                        <template v-if="request.report.ovam_conclusion_id">
                                            {{ ovamConclusions[request.report.ovam_conclusion_id] }}
                                        </template>
                                    </Td>
                                </tr>
                                <tr class="nohover" v-if="request.status === 'reported' && this.$page.props.user.permissions.includes('requests.report')">
                                    <Td class="border-0 pl-0" colspan="2">
                                        <Button
                                            text="Rapportage bewerken"
                                            @click="editReport"
                                        />
                                    </Td>
                                </tr>
                            </Table>
                        </div>
                    </div>
                    <h4 class="mt-4 mb-2">OVAM rapport(en)</h4>
                    <Table :id="'request-report-attachments-' + request.id" :values="request.attachments">
                        <thead>
                        <tr>
                            <Th id="file">Bestand</Th>
                            <Th id="created_at">Toegevoegd op</Th>
                            <Th id="user.name">Toegevoegd door</Th>
                            <Th id="send">Verzonden</Th>
                            <Th :sort="false"></Th>
                        </tr>
                        </thead>
                        <tbody>
                            <template v-for="attachment in state.sortedValues['request-report-attachments-' + request.id]" :key="attachment.id">
                                <tr v-if="attachment.type === 'OVAM rapport'">
                                    <Td>
                                        <a :href="'/requests/' + request.id + '/download-attachment?filename=' + encodeURIComponent(attachment.file)">
                                            {{ attachment.file }}
                                        </a>
                                    </Td>
                                    <Td>{{ moment(attachment.created_at).format('DD/MM/YYYY HH:mm') }}</Td>
                                    <Td>
                                        <template v-if="attachment.user">
                                            {{ attachment.user.name }}
                                        </template>
                                    </Td>
                                    <Td class="text-center">
                                        <i class="fas fa-check text-blue-dark-500" v-if="attachment.send"></i>
                                    </Td>
                                    <Td>
                                        <Modal buttonClass="info" buttonSize="small" v-if="attachment.send">
                                            <h3>Info</h3>
                                            <strong>{{ attachment.file }}</strong>
                                            <table class="mt-4">
                                                <tr>
                                                    <th class="text-left pr-4">Ontvanger</th>
                                                    <th class="text-left pr-4">Verzonden op</th>
                                                </tr>
                                                <tr v-for="(attachmentReceiver, key) in attachment.attachment_receivers">
                                                    <td class="pr-4">{{ attachmentReceiver.receiver }}</td>
                                                    <td>{{ moment(attachmentReceiver.send_at).format('DD/MM/YYYY HH:mm') }}</td>
                                                </tr>
                                            </table>
                                        </Modal>
                                    </Td>
                                </tr>
                            </template>
                        </tbody>
                    </Table>
                </div>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import InputGroup from '@/Components/InputGroup.vue'
import Select from '@/Components/Select.vue'
import Textarea from '@/Components/Textarea.vue'

import Cancel from '@/Components/Requests/Cancel.vue'
import ModalAttachments from "@/Components/Requests/ModalAttachments.vue";
import ModalPlanVisit from "@/Components/Requests/ModalPlanVisit.vue";
import ModalCreditNote from "@/Components/Requests/ModalCreditNote.vue";

import store from '@/store'
import moment from "moment";
import {useForm} from "@inertiajs/inertia-vue3"
import { ref } from "vue"
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        Modal,
        Form,
        Input,
        InputGroup,
        Select,
        Textarea,
        Cancel,
        ModalAttachments,
        ModalPlanVisit,
        ModalCreditNote,
    },
    props: [
        'request',
        'requestTypes',
        'attachmentTypes',
        'attachmentsPath',
        'attachments',
        'ovamReports',
        'sendOVAMReportTo',
        'executors',
        'statusses',
        // 'overdueReasons',
        'postInvoiceReasons',
        'ovamConclusions',
        'externalRequestForms',
        'hasOffer',
        'failedEmails',
    ],
    setup (props)
    {
        let modalRegisterVisit = ref(null)
        let modalReport = ref(null)
        let modalDuedateInfo = ref(null)
        let modalProForma = ref(null)
        let modalPostInvoice = ref(null)
        let modalInvoiceInfo = ref(null)
        let modalInvoiced = ref(null)
        let modalEditResendEmail = ref(null)
        let modalSendReport = ref(null)
        let requestTypeOptions = {}
        let allExecutors = {}//All executors, also blocked ones
        let executorOptions = {}//All executors, except blocked ones
        let visitOptions = ref({})
        // let overdueReasonOptions = {}
        let postInvoiceReasonOptions = {}
        let replanVisit = ref(false)
        let visitToReplan = ref(null)
        let extraVisit = ref(false)
        let createCreditNote = ref(false)
        let cancelRequest = ref(false)
        let sendingOffer = ref(false)
        let approving = ref(false)
        let resendingEmail = ref([])
        let formEditResendEmail = []

        props.requestTypes.forEach(function(requestType) {
            requestTypeOptions[requestType.id] = requestType.type
        })

        props.executors.forEach(function(executor) {
            allExecutors[executor.username] = executor.name

            if (executor.status !== 'blocked')
            {
                executorOptions[executor.username] = executor.name
            }

            if (executor.status === 'pending')
            {
                allExecutors[executor.username] += ' (Nog niet in dienst)'
                executorOptions[executor.username] += ' (Nog niet in dienst)'
            }
        })

        // props.overdueReasons.forEach(function(overdueReason) {
        //     overdueReasonOptions[overdueReason.id] = overdueReason.reason
        // })

        props.postInvoiceReasons.forEach(function(postInvoiceReason) {
            postInvoiceReasonOptions[postInvoiceReason.id] = postInvoiceReason.reason
        })

        props.failedEmails.forEach(function(failedEmail) {
            resendingEmail.value[failedEmail.id] = false
        })

        const formRegisterVisit = useForm({
            request_id: props.request.id,
            visit_id: null,
            transport_time_hours: null,
            transport_time_minutes: null,
            visit_time_hours: null,
            visit_time_minutes: null,
            qlab: null,
            lims: null,
            samples: null,
            extra_visit: false,
        })

        setVisitOptions()

        function setVisitOptions()//For registering visits
        {
            visitOptions.value = {}

            //Check visits
            if (props.request.visits && props.request.visits.length >= 1)
            {
                props.request.visits.forEach(function(visit) {
                    if (visit.transport_time === null && visit.visit_time === null && visit.qlab === null &&
                        (visit.lims === null || visit.lims === 0 || visit.lims === '0') && visit.samples === null)//planned, not registered
                    {
                        visitOptions.value[visit.id] = visit.planned_at + ' - ' + executorOptions[visit.executor]
                    }
                })

                if (Object.keys(visitOptions.value).length === 1)
                {
                    formRegisterVisit.visit_id = parseInt(Object.keys(visitOptions.value)[0])
                }
            }
        }

        const formReport = useForm({
            reported_at: null,
            spent_time_hours: null,
            spent_time_minutes: null,
            plans_available: null,
            no_ovam_report: 0,
            certificate_date: null,
            ovam_conclusion_id: null,
            request_form_external_id: (Object.keys(props.externalRequestForms).length === 1) ? Object.keys(props.externalRequestForms)[0] : null,//Dewaele request form uuid (opdrachtformulier)
            report_attachments: null,
            request_id: props.request.id,
        })

        const formDuedateInfo = useForm({
            duedate_unknown: false,
            new_duedate: null,
            overdue_info: null,
            // overdue_reason_id: null,
            request_id: props.request.id,
        })

        const formProForma = useForm({
            remark: null,
            request_id: props.request.id,
        })

        const formPostInvoice = useForm({
            info_asbestos: null,
            post_invoice_attachment: null,
            post_invoice_reason_id: null,
            request_id: props.request.id,
        })

        const formInvoiceInfo = useForm({
            same_address: false, //for inspection address = invoice customer address
            invoice_customer_id: (props.request !== null) ? props.request.invoice_customer_id : null,
            invoice_customer_name: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.name : null,
            invoice_customer_company: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.company : null,
            invoice_customer_address: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.address : null,
            invoice_customer_address_info: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.address_info : null,
            invoice_customer_place: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.place : null,
            invoice_customer_postal_code: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.postal_code : null,
            invoice_customer_country_code: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.country_code : "BE",
            invoice_customer_vat_number: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.vat_number : null,
            invoice_customer_email: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.email : null,
            invoice_customer_phone: (props.request !== null && props.request.invoice_customer !== null) ? props.request.invoice_customer.phone : null,
            invoice_number: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.number : null,
            invoice_paid_at: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.paid_at : null,
            invoice_amount: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.amount : null,
            invoice_info: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.info : null,
            request_id: props.request.id,
        })

        const formInvoiced = useForm({
            invoice_number: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.number : null,
            invoice_amount: (props.request !== null && props.request.invoice !== null) ? props.request.invoice.amount : null,
            no_invoice: 0,
            request_id: props.request.id,
        })

        function SendOffer()
        {
            if (!confirm('Bent u zeker dat u de offerte wil versturen?'))
                return

            sendingOffer.value = true

            Inertia.get('/requests/' + props.request.id + '/send-offer', {
                onSuccess: () => {
                    sendingOffer.value = false
                }
            })
        }

        function approveRequest()
        {
            approving.value = true

            Inertia.get('/requests/' + props.request.id + '/approve', {
                onSuccess: () => {
                    approving.value = false
                }
            })
        }

        function replanRequestVisit(visit)
        {
            visitToReplan.value = visit
            replanVisit.value = true
        }

        function visitReplanned()
        {
            replanVisit.value = false
            setVisitOptions()
        }

        function postRegisterVisit()
        {
            formRegisterVisit.post(route('requests.register-visit'), {
                onSuccess: () => {
                    extraVisit.value = formRegisterVisit.extra_visit
                    formRegisterVisit.reset()
                    modalRegisterVisit.value.show = false
                    setVisitOptions()
                },
            })
        }

        function editRegisterVisit()
        {
            formRegisterVisit.request_id = props.request.id
            formRegisterVisit.visit_id = props.request.visits[props.request.visits.length - 1].id
            formRegisterVisit.transport_time_hours = (props.request.visits[props.request.visits.length - 1].transport_time !== null) ?
                moment(props.request.visits[props.request.visits.length - 1].transport_time, 'HH:mm:ss').format('HH') : null
            formRegisterVisit.transport_time_minutes = (props.request.visits[props.request.visits.length - 1].transport_time !== null) ?
                moment(props.request.visits[props.request.visits.length - 1].transport_time, 'HH:mm:ss').format('mm') : null
            formRegisterVisit.visit_time_hours = (props.request.visits[props.request.visits.length - 1].visit_time !== null) ?
                parseInt(props.request.visits[props.request.visits.length - 1].visit_time.substring(0, 2)) : null
            formRegisterVisit.visit_time_minutes = (props.request.visits[props.request.visits.length - 1].visit_time !== null) ?
                parseInt(props.request.visits[props.request.visits.length - 1].visit_time.substring(3, 5)) : null
            formRegisterVisit.qlab = props.request.visits[props.request.visits.length - 1].qlab
            formRegisterVisit.lims = props.request.visits[props.request.visits.length - 1].lims
            formRegisterVisit.samples = props.request.visits[props.request.visits.length - 1].samples
            formRegisterVisit.extra_visit = false

            modalRegisterVisit.value.show = true
        }

        function postFormReport()
        {
            formReport.post(route('requests.store-report'), {
                onSuccess: () => {
                    formReport.reset()
                    modalReport.value.show = false
                    attachmentIds = [];
                    attachmentExternalIds = {}
                    setSendReportAttachmentIds()

                    formSendReport.attachment_ids = attachmentIds
                    formSendReport.attachment_external_ids = attachmentExternalIds
                },
            })
        }

        function editReport()
        {
            formReport.reported_at = props.request.report.reported_at
            formReport.spent_time_hours = (props.request.report.spent_time !== null) ? moment(props.request.report.spent_time, 'HH:mm:ss').format('HH') : null
            formReport.spent_time_minutes = (props.request.report.spent_time !== null) ? moment(props.request.report.spent_time, 'HH:mm:ss').format('mm') : null
            formReport.no_ovam_report = props.request.report.no_ovam_report
            formReport.certificate_date = props.request.report.certificate_date
            formReport.plans_available = props.request.report.plans_available
            formReport.ovam_conclusion_id = props.request.report.ovam_conclusion_id
            formReport.request_form_external_id = props.request.report.request_form_external_id
            formReport.report_attachments = null
            formReport.request_id = props.request.id

            modalReport.value.show = true
        }

        function postFormDuedateInfo()
        {
            formDuedateInfo.post(route('requests.store-duedate-info'), {
                onSuccess: () => {
                    formDuedateInfo.reset()
                    modalDuedateInfo.value.show = false
                },
            })
        }

        function postFormProForma()
        {
            formProForma.post(route('requests.store-pro-forma'), {
                onSuccess: () => {
                    formProForma.reset()
                    modalProForma.value.show = false
                },
            })
        }

        function postFormPostInvoice()
        {
            formPostInvoice.post(route('requests.store-post-invoice'), {
                onSuccess: () => {
                    formPostInvoice.reset()
                    modalPostInvoice.value.show = false
                },
            })
        }

        function sameAddress()
        {
            if (Boolean(formInvoiceInfo.same_address))
            {
                formInvoiceInfo.invoice_customer_name = props.request.inspection_address.name
                formInvoiceInfo.invoice_customer_address = props.request.inspection_address.address
                formInvoiceInfo.invoice_customer_place = props.request.inspection_address.place
                formInvoiceInfo.invoice_customer_postal_code = props.request.inspection_address.postal_code
            }
        }

        function postFormInvoiceInfo()
        {
            formInvoiceInfo.post(route('requests.store-invoice-info'), {
                onSuccess: () => {
                    modalInvoiceInfo.value.show = false
                    formInvoiceInfo.clearErrors()
                    formInvoiceInfo.reset()

                    formInvoiceInfo.invoice_customer_id = props.request.invoice_customer_id
                    formInvoiceInfo.invoice_customer_name = (props.request.invoice_customer !== null) ? props.request.invoice_customer.name : null
                    formInvoiceInfo.invoice_customer_company = (props.request.invoice_customer !== null) ? props.request.invoice_customer.company : null
                    formInvoiceInfo.invoice_customer_address = (props.request.invoice_customer !== null) ? props.request.invoice_customer.address : null
                    formInvoiceInfo.invoice_customer_address_info = (props.request.invoice_customer !== null) ? props.request.invoice_customer.address_info : null
                    formInvoiceInfo.invoice_customer_place = (props.request.invoice_customer !== null) ? props.request.invoice_customer.place : null
                    formInvoiceInfo.invoice_customer_postal_code = (props.request.invoice_customer !== null) ? props.request.invoice_customer.postal_code : null
                    formInvoiceInfo.invoice_customer_country_code = (props.request.invoice_customer !== null) ? props.request.invoice_customer.country_code : "BE"
                    formInvoiceInfo.invoice_customer_vat_number = (props.request.invoice_customer !== null) ? props.request.invoice_customer.vat_number : null
                    formInvoiceInfo.invoice_customer_email = (props.request.invoice_customer !== null) ? props.request.invoice_customer.email : null
                    formInvoiceInfo.invoice_customer_phone = (props.request.invoice_customer !== null) ? props.request.invoice_customer.phone : null
                    formInvoiceInfo.invoice_number = (props.request.invoice !== null) ? props.request.invoice.number : null
                    formInvoiceInfo.invoice_paid_at = (props.request.invoice !== null) ? props.request.invoice.paid_at : null
                    formInvoiceInfo.invoice_amount = (props.request.invoice !== null) ? props.request.invoice.amount : null
                    formInvoiceInfo.invoice_info = (props.request.invoice !== null) ? props.request.invoice.info : null
                    formInvoiceInfo.request_id = props.request.id

                    formInvoiced.invoice_number = (props.request.invoice !== null) ? props.request.invoice.number : null
                    formInvoiced.invoice_amount = (props.request.invoice !== null) ? props.request.invoice.amount : null
                },
            })
        }

        function postFormInvoiced() {
            formInvoiced.post(route('requests.store-invoiced'), {
                onSuccess: () => {
                    formInvoiceInfo.invoice_number = (props.request.invoice !== null) ? props.request.invoice.number : null
                    formInvoiceInfo.invoice_amount = (props.request.invoice !== null) ? props.request.invoice.amount : null
                  },
            })
        }

        function createRequestCreditNote(cancel = false)
        {
            createCreditNote.value = true
            cancelRequest.value = cancel
        }

        //To edit failed emails
        formEditResendEmail = useForm({
            id: null,
            mail_to:  null,
            subject: null,
        })

        function resendEmail(failedEmail)
        {
            resendingEmail.value[failedEmail.id] = true

            Inertia.post('/requests/failed-emails/' + failedEmail.id + '/resend', {
                onSuccess: () => {
                    resendingEmail.value[failedEmail.id].value = false
                }
            })
        }

        function editResendEmail(failedEmail)
        {
            formEditResendEmail.id = failedEmail.id
            formEditResendEmail.mail_to = failedEmail.mail_to
            formEditResendEmail.subject = failedEmail.subject

            modalEditResendEmail.value.show = true
        }

        function postEditResendEmail()
        {
            formEditResendEmail.put('/requests/failed-emails/' + formEditResendEmail.id, {
                onSuccess: () => {
                    modalEditResendEmail.value.show = false
                    form.clearErrors()
                    form.reset()
                }
            })
        }

        function deleteResendEmail(failedEmail)
        {
            if (!confirm('Bent u zeker dat u deze e-mail wil verwijderen zonder deze te verzenden?'))
                return

            Inertia.delete('/requests/failed-emails/' + failedEmail.id)
        }

        function deleteAttachment(attachment)
        {
            if (!confirm('Bent u zeker dat u deze bijlage wil verwijderen? (' + attachment.file + ')')
            )
                return

            Inertia.delete(route('requests.delete-attachment', { 'attachment': attachment.id }))
        }

        let attachmentIds = [];
        let attachmentExternalIds = {};

        function setSendReportAttachmentIds()
        {
            //Get all attachment OVAM report ids
            //We need to do this, so we can set the default selected attachment ids in the form
            props.request.attachments.forEach(function(attachment)
            {
                if (attachment.type === 'OVAM rapport')
                {
                    attachmentIds.push(attachment.id)
                    attachmentExternalIds[attachment.id] = (props.externalRequestForms.hasOwnProperty(attachment.external_id)) ? attachment.external_id : Object.keys(props.externalRequestForms)[0]
                }
            })
        }

        setSendReportAttachmentIds();

        //To send OVAM reports
        const formSendReport = useForm({
            to: props.sendOVAMReportTo,//Array with values that are checked by default
            extra_emails:  null,
            attachment_ids: attachmentIds,
            attachment_external_ids: attachmentExternalIds,
        })

        function postFormSendReport()
        {
            if (confirm('Bent u zeker dat u de rapport(en) wil verzenden naar de opgegeven personen?'))
            {
                formSendReport.post(route('requests.send-report', { 'request': props.request.id }), {
                    onSuccess: () => {
                        modalSendReport.value.show = false
                    },
                })
            }
        }

        return {
            state: store.state,
            ...store,
            modalRegisterVisit,
            modalReport,
            modalProForma,
            modalPostInvoice,
            modalInvoiceInfo,
            modalInvoiced,
            requestTypeOptions,
            allExecutors,
            executorOptions,
            formRegisterVisit,
            postRegisterVisit,
            editRegisterVisit,
            formReport,
            postFormReport,
            editReport,
            formProForma,
            postFormProForma,
            formPostInvoice,
            postFormPostInvoice,
            formDuedateInfo,
            postFormDuedateInfo,
            visitOptions,
            replanRequestVisit,
            replanVisit,
            visitToReplan,
            visitReplanned,
            extraVisit,
            modalDuedateInfo,
            // overdueReasonOptions,
            postInvoiceReasonOptions,
            formInvoiceInfo,
            postFormInvoiceInfo,
            formInvoiced,
            postFormInvoiced,
            sameAddress,
            createRequestCreditNote,
            createCreditNote,
            cancelRequest,
            SendOffer,
            sendingOffer,
            approveRequest,
            approving,
            resendEmail,
            resendingEmail,
            modalEditResendEmail,
            editResendEmail,
            postEditResendEmail,
            formEditResendEmail,
            deleteResendEmail,
            deleteAttachment,
            postFormSendReport,
            formSendReport,
            modalSendReport,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>

<style scoped>
tr.nohover:hover td  {
    background: none;
}
</style>
